export default {
	path: "/",
	name: "onboarding.index",
	component: () => import("@/view/onboarding/index"),
	meta: {
		protected: false,
	},
};
